module.exports = __webpack_public_path__ + "static/media/fisdom_logo.c6fc18a7.svg";